import React from "react";
import InternshipDirectoryListing from "./listing";

export default function CompletedInternshipDirectory(props) {
  return (
    <InternshipDirectoryListing
      {...props}
      fetchType="completed"
      title="Directory of Internships Completed"
      pageTitle="Directory of Internships Completed"
      dateLabel="Completed On"
      emptyMessage="No completed internships found"
    />
  );
}
